module.exports = __webpack_public_path__ + "img/ict-sme.c6f18740.png";